<div mat-dialog-title>
  {{ data.data[0].TOPIC_NAME }}
  <div style="float: right; margin-top: -5px;">
    <button mat-icon-button [mat-dialog-close]="true" (click)="closeModal()">
      <img src="../../../../assets/close-white.png" style="width: 12px;">
    </button>
  </div>
</div>

<mat-dialog-content class="mat-typography">
  <form [formGroup]="quizForm">
    <div formArrayName="questions" *ngFor="let q of data.data[0].VALUE; let i = index">
      <ng-container [formGroupName]="i">
        <label>{{ i+1 }}. {{ q.QUESTION }}</label>
        <mat-radio-group class="radio-group" formControlName="ANSWER">
          <div *ngFor="let c of q.VALUE">
            <img *ngIf="c.OPTION_PIC" [src]="c.OPTION_PIC" width="100px" style="margin-left: 33px;">
            <br *ngIf="c.OPTION_PIC">
            <mat-radio-button class="radio-button" [value]="c">
              {{ c.OPTION_NAME }}
            </mat-radio-button>
          </div>
        </mat-radio-group>
      </ng-container>
    </div>
  </form>
</mat-dialog-content>

<div align="center" style="padding-bottom: 20px">
  <div>
    <button *ngIf="quizForm.valid" (click)="sendAnswer(quizForm.value)" mat-button
      style="background: #3E8C1A; color: #fff;">
      {{ data.actionBtnText }}
    </button>
    <button *ngIf="!quizForm.valid" mat-button [disabled]="true">
      {{ data.actionBtnText }}
    </button>
  </div>
</div>
